$(function () {
    function closeSiblings(selector, $opening, $scope) {
        var $root = $scope && $scope.length ? $scope : $(document);
        $root.find(selector + '.show').not($opening).each(function () {
            $(this).collapse('hide');
        });
    }

    function categoryShow(e) {
        if (!$(e.target).hasClass('faq-group-items')) return;
        closeSiblings('.faq-group-items', $(e.target), $(document));
    }

    function questionShow(e) {
        if (!$(e.target).hasClass('faq-answer')) return;
        var $opening = $(e.target);
        var $scope = $opening.closest('.faq-group');
        closeSiblings('.faq-answer', $opening, $scope.length ? $scope : $(document));
    }

    $(document)
        .on('show.bs.collapse', '.faq-group-items', categoryShow)
        .on('show.bs.collapse', '.faq-answer', questionShow);
});
